/**
 * Кто из команд капитана может заявиться в турнир нужного размера.
 *
 * KAN-1621: `maxMembers` — это ВМЕСТИМОСТЬ ростера, а не основной состав.
 * Команда «5 основных + запасные» имеет maxMembers = 10, поэтому проверка
 * `maxMembers === requiredTeamSize` прятала её от капитана, хотя сервер такие
 * команды принимает: `TournamentService.RegisterTeamAsync` требует ровно N
 * стартеров (Role != Substitute/Coach), а запасные и тренер идут сверх и не
 * считаются.
 *
 * Для Arena ролей нет и сервер требует ровно N участников в команде, поэтому
 * там сравниваем фактическое число участников: команда на 4 человека в 3×3
 * не должна выглядеть подходящей.
 */
export type RegistrationTeamLike = {
  maxMembers?: number | null;
  memberCount?: number | null;
  archivedAt?: string | null;
};

export function isTeamEligibleForRegistration(
  team: RegistrationTeamLike,
  requiredTeamSize: number,
  arenaMode: boolean,
): boolean {
  // Архивные (temp-команды отменённых/завершённых турниров) не предлагаем:
  // иначе «фантом» из старого турнира протекает в форму новой регистрации,
  // а бэкенд такую команду отклоняет.
  if (team.archivedAt) return false;

  if (arenaMode) {
    return (team.memberCount ?? 0) === requiredTeamSize;
  }

  // Classic: вместимость должна позволять выставить нужный основной состав.
  // Неполную команду не скрываем — форма показывает причину отказа (KAN-109).
  return (team.maxMembers ?? 0) >= requiredTeamSize;
}
